import { Button } from "flowbite-react";
import { FiX } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ButtonCloseModal = (props) =>   {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "gray",
    className: `rounded-[6px] min-w-[69px] h-[32px] ${props.className}`,
  };

  return (
    <Button {...tmpProps} onClick={props.onClick}>
      <FiX />
    </Button>
  );
};

export default ButtonCloseModal;